// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__odLCJ","show":"styles_show__ldr5U","tooltip_right":"styles_tooltip_right__44Heg","tooltip_bottom":"styles_tooltip_bottom__QwAur"};